export type KeyboardWizardMode = "fullscreen" | "modal";

export enum KeyboardWizardPage {
  ChooseDevice = "ChooseDevice",
  SetLowestNote = "SetLowestNote",
  SetHighestNote = "SetHighestNote",
  SetupComplete = "SetupComplete",
}

